import { Error, Input } from 'components';
import { LoginFieldNames } from 'model';
import React, { FC } from 'react';
import { Field } from 'redux-form';
import { email, required } from 'utils/validations';
import connect from './connect';
import {
  ButtonPrimary,
  Container,
  ResetPassword,
  Row,
  SignUpLink,
  SignUpText,
} from './styles';
import { Props } from './types';

const Form: FC<Props> = ({
  error,
  handleSubmit,
  invalid,
  loading,
  pristine,
  search,
}) => (
  <Container onSubmit={handleSubmit}>
    <Field
      autocomplete="username"
      component={Input}
      label="Email"
      name={LoginFieldNames.email}
      placeholder="Enter your email"
      type="text"
      validate={[email, required]}
    />
    <Field
      autocomplete="current-password"
      component={Input}
      label="Password"
      name={LoginFieldNames.password}
      placeholder="Enter your password"
      type="password"
      validate={required}
    />
    {error && <Error text={error} />}
    <Row>
      <ButtonPrimary disabled={invalid || loading || pristine} type="submit">
        {loading ? 'Loading...' : 'Log in'}
      </ButtonPrimary>
      <ResetPassword to="/reset-password">Forgot your password?</ResetPassword>
    </Row>
    <SignUpText>
      Don’t have an account?{' '}
      <SignUpLink to={{ search, pathname: '/sign-up' }}>Sign up</SignUpLink>
    </SignUpText>
  </Container>
);

export default connect(Form);
